'use strict';

/**
 * DataCaptureUtil
 *
 * Methods that parse and format DataCaptures so that it is ready to be passed
 * into angular-leaflet
 */

var _ = require('lodash');

function DataCaptureUtil (tileUtil) {

  /**
   * Extract the layers from the list of datacaptures
   *
   * @param  {Array.<Object>} datacaptures List of Datacaptures
   * @return {Object.<Object>} Object representing a collection of tile layers
   */
  this.getLayers = function (datacaptures, options) {
    return _.reduce(datacaptures, function (tilelayers, dc) {
      //datacaptures are inted on null values
      if(!dc){
        return;
      }

      var params = {
        dataCaptureId: dc.id
      };

      Object.keys(options || {}).forEach(function (key) {
        params[key] = options[key];
      });

      var _tileLayers = tileUtil.getTileLayers(dc.layers, 'datacapture', null, null, params);
      return _.extend(tilelayers, _tileLayers);
    }, {});
  };
}

DataCaptureUtil.$inject = ['tileUtil'];
module.exports = DataCaptureUtil;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/utils/DataCaptureUtil.js